import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  advancedShippingNoticesTitle: {
    description: 'Advance Shipping Notices tab panel title',
    defaultMessage: 'Advance Shipping Notices',
    id: 'C+FjBw',
  },
  advancedShippingNoticesSubTitle: {
    description: 'Advance Shipping Notices tab panel sub-title',
    defaultMessage: 'Use an Advance Shipping Notice to send inventory to a Fulfilled by ShipStation warehouse and track your requests.',
    id: 'woGOxy',
  },
  createNoticeButtonText: {
    defaultMessage: 'Create Notice',
    id: '3YXtbQ',
    description: 'Create Advance Shipping Notice button text',
  },
  draftNotices: {
    defaultMessage: 'Draft Notices',
    id: 'wOkhVz',
    description: 'Name of the draft notices table',
  },
  submittedNotices: {
    defaultMessage: 'Submitted Notices',
    id: 'RlNE4P',
    description: 'Name of the submitted notices table',
  },
  completedNotices: {
    defaultMessage: 'Completed Notices',
    id: 'QH/PkP',
    description: 'Name of the completed notices table',
  },
  errorNotificationGetASNsTitle: {
    defaultMessage: 'An Error Occurred.',
    id: 'CqeiTE',
    description: 'Notification text to inform user there was an error getting their Advance Shipping Notices',
  },
  errorNotificationGetASNsMessage: {
    defaultMessage: 'Error retrieving your Advance Shipping Notices. Please refresh and try again.',
    id: 'c+KxWp',
    description: 'Notification text to inform user there was an error getting their Advance Shipping Notices',
  },
  errorNotificationDeleteTitle: {
    defaultMessage: 'Error Deleting Advance Shipping Notice',
    id: 'l3vbHp',
    description: 'Notification Title Text to inform user there was an error deleting their ASN',
  },
  errorNotificationDeleteMessage: {
    defaultMessage: 'An error occurred deleting your Advance Shipping Notice. Please refresh and try again.',
    id: 'L03xpR',
    description: 'Notification Title Text to inform user there was an error deleting their ASN',
  },
  errorNotificationCancelTitle: {
    defaultMessage: 'Error Canceling Advance Shipping Notice',
    id: 'AJxCOF',
    description: 'Notification Title Text to inform user there was an error cancel their ASN',
  },
  errorNotificationCancelMessage: {
    defaultMessage: 'An error occurred canceling your Advance Shipping Notice. Please refresh and try again.',
    id: 'JmHnVm',
    description: 'Notification Title Text to inform user there was an error cancel their ASN',
  },
  errorNotificationDuplicateTitle: {
    defaultMessage: 'Error Duplicating Advance Shipping Notice',
    id: 'EXu2DQ',
    description: 'Notification Title Text to inform user there was an error duplicating their ASN',
  },
  errorNotificationDuplicateMessage: {
    defaultMessage: 'An error occurred duplicating your Advance Shipping Notice. Please refresh and try again.',
    id: 'TFvRar',
    description: 'Notification Message Text to inform user there was an error duplicating their ASN',
  },
  successNotificationDuplicateTitle: {
    defaultMessage: 'Advance Shipping Notice Duplicated',
    id: 'u+niD1',
    description: 'Notification Title Text to inform user their ASN was successfully duplicated',
  },
  successNotificationDuplicateMessage: {
    defaultMessage: 'Your Advance Shipping Notice has been successfully duplicated.',
    id: '2Rkw5P',
    description: 'Notification Message Text to inform user their ASN was successfully duplicated',
  },
  successNotificationDeleteTitle: {
    defaultMessage: 'Advance Shipping Notice Deleted',
    id: 'pugN1l',
    description: 'Notification Title Text to inform user their ASN was successfully deleted',
  },
  successNotificationDeleteMessage: {
    defaultMessage: 'Your Advance Shipping Notice has been successfully deleted.',
    id: 'yYDJMJ',
    description: 'Notification Message Text to inform user their ASN was successfully deleted',
  },
  successNotificationCancelTitle: {
    defaultMessage: 'Advance Shipping Notice Canceled',
    id: 'Jgqbfb',
    description: 'Notification Title Text to inform user their ASN was successfully canceled',
  },
  successNotificationCancelMessage: {
    defaultMessage: 'Your Advance Shipping Notice has been successfully canceled.',
    id: '2jxiUu',
    description: 'Notification Message Text to inform user their ASN was successfully canceled',
  },
});
